// Release step keys mirror backend/app/source_components/* release()
// and on_step_completed() metadata.step values.
const RELEASE_STEP_CONFIG = {
  openmetadata: {
    branch: { name: 'branch', label: 'Create Release Branch' },
    oss_pypi: { name: 'oss_pypi', label: 'OSS PyPI Publish' },
    mysql_image: { name: 'mysql_image', label: 'MySQL Image' },
    psql_image: { name: 'psql_image', label: 'Postgres Image' },
    oss_maven: { name: 'oss_maven', label: 'OSS Maven Publish' },
    oss_gha_release: { name: 'oss_gha_release', label: 'OSS GitHub Release' },
    oss_image: { name: 'oss_image', label: 'OSS Server Image' },
    oss_ingestion_base_slim_image: {
      name: 'oss_ingestion_base_slim_image',
      label: 'OSS Ingestion Base Slim Image',
    },
    oss_ingestion_base_image: {
      name: 'oss_ingestion_base_image',
      label: 'OSS Ingestion Base Image',
    },
    oss_ingestion_image: { name: 'oss_ingestion_image', label: 'OSS Ingestion Image' },
    k8s_operator_image: { name: 'k8s_operator_image', label: 'K8s Operator Image' },
  },
  collate: {
    branch: { name: 'branch', label: 'Create Release Branch' },
    collate_gha_release: { name: 'collate_gha_release', label: 'Collate GitHub Release' },
    collate_publish: { name: 'collate_publish', label: 'Collate Publish' },
    collate_local_ingestion: {
      name: 'collate_local_ingestion',
      label: 'Collate Local Ingestion',
    },
  },
  'hybrid-runner': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'hybrid-runner_release': {
      name: 'hybrid-runner_release',
      label: 'Hybrid Runner Release',
    },
  },
  'ai-platform': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    collate_ai_image: { name: 'collate_ai_image', label: 'Collate AI Image' },
  },
  construct: {
    branch: { name: 'branch', label: 'Create Release Branch' },
    construct_tests: { name: 'construct_tests', label: 'Construct Tests' },
    construct_image: { name: 'construct_image', label: 'Construct Image' },
  },
  'openmetadata-helm-charts': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'openmetadata-helm-charts_version_bump': {
      name: 'openmetadata-helm-charts_version_bump',
      label: 'Version Bump',
    },
    'openmetadata-helm-charts_publish': {
      name: 'openmetadata-helm-charts_publish',
      label: 'Publish Charts',
    },
  },
  'hybrid-helm': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'hybrid-helm_version_bump': { name: 'hybrid-helm_version_bump', label: 'Version Bump' },
    'hybrid-helm_publish': { name: 'hybrid-helm_publish', label: 'Publish Charts' },
  },
  'ai-proxy-helm': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'ai-proxy-helm_version_bump': { name: 'ai-proxy-helm_version_bump', label: 'Version Bump' },
    'ai-proxy-helm_publish': { name: 'ai-proxy-helm_publish', label: 'Publish Charts' },
  },
  'terraform-aws': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'terraform-aws_version_bump': { name: 'terraform-aws_version_bump', label: 'Version Bump' },
    'terraform-aws_publish': { name: 'terraform-aws_publish', label: 'Tag & Release' },
  },
  'terraform-deploy': {
    branch: { name: 'branch', label: 'Create Release Branch' },
    'terraform-deploy_version_bump': {
      name: 'terraform-deploy_version_bump',
      label: 'Version Bump',
    },
  },
};

function titleizeStep(key) {
  return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getReleaseStepMeta(component, key) {
  return RELEASE_STEP_CONFIG[component]?.[key] || {
    name: key,
    label: titleizeStep(key),
  };
}
